import React from "react";
import Select from "react-select";

const SelectBox = ({ selectedValue, onChangeFn, options, label, error ,isSearchable}) => {
    const handleChange = (selectedOption) => {
        onChangeFn(selectedOption?.value);
    };
    return (
        <div className="custom-form-group">
            <label htmlFor="roles" className="pb-2 position-relative">{label}</label>
            <Select
                options={options}
                label={label ?? "Select"}
                value={options.find(option => option?.value == selectedValue)}
                onChange={handleChange}
                styles={{
                    control: (provided, state) => ({
                        ...provided,
                        border: "none",
                        boxShadow: state.isFocused ? "none" : provided.boxShadow,
                        outline: "none",
                    })
                }}
                className="country-select"
                isSearchable={isSearchable}
            />
            {error && <div className="error-text">{error}</div>}
            <hr className={error ? "error-hr-line" : ""} />
        </div>
    );
};

export default SelectBox;
